var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"m-0 d-flex flex-column justify-content-center align-items-center"},[_c('a',{attrs:{"href":"https://www.sunwaypyramid.com"}},[_c('div',{},[_c('img',{staticClass:"img-fluid logo",attrs:{"src":"images/top-image.png"}})])])])
}]

export { render, staticRenderFns }